import { createListFilters } from '../../../../components'

export type TermosFilters = {
  /** Título do termo (busca parcial). */
  titulo: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<TermosFilters>({
  titulo: '',
})
